import { render, staticRenderFns } from "./vaativuustaso-tooltip-content.vue?vue&type=template&id=7974ff56&"
import script from "./vaativuustaso-tooltip-content.vue?vue&type=script&lang=ts&"
export * from "./vaativuustaso-tooltip-content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports